import React, { useEffect, useState } from "react";
import "../Styles/Home.css";

import { useNavigate } from "react-router-dom";

// Images
import Logo from "../../Images/Logo-T.png";

// Icons
import { FaChartLine, FaDatabase, FaCloud } from "react-icons/fa";

function Home() {
  const [showSticky, setShowSticky] = useState(false);
  const nav = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="Home">

      {/* 🔥 STICKY CTA */}
      <div className={`sticky-cta ${showSticky ? "show" : ""}`}>
        <button className="primary-btn">התחילו עכשיו</button>
        <button className="secondary-btn" onClick={() => nav("/Login")}>
          התחברות
        </button>
      </div>

      {/* HERO */}
      <section className="sec-1">
        <div className="hero-left">
          <h1>
            מנהלים חכם יותר עם <span className="logo-text">Techrunow</span>
          </h1>

          <p>
            Techrunow היא מערכת SaaS מתקדמת לניהול עסקים וארגונים המספקת פתרון כולל לניהול מידע,
            אחסון קבצים בענן (Cloud Storage), CRM לניהול לקוחות, ניהול עובדים, אוטומציה של תהליכים עסקיים
            ואינטגרציה בין מערכות — הכל בפלטפורמה אחת חכמה, מאובטחת וסקלאבילית המתאימה לעסקים קטנים,
            חברות וארגונים גדולים.
          </p>

          <div className="hero-buttons">
            <button className="primary-btn">התחילו עכשיו</button>
            <button className="secondary-btn" onClick={() => nav("/Login")}>
              התחברות
            </button>
          </div>
        </div>

        <div className="hero-right">
          <img src={Logo} alt="Techrunow Logo" />
        </div>
      </section>

      {/* PLATFORM */}
      <section className="sec-2 fade-section">
      
        <h2>מה הפלטפורמה שלנו מספקת?</h2>
      
        <p className="section-subtitle">
          Techrunow היא פלטפורמה חכמה לניהול ארגונים המשלבת אחסון קבצים, ניהול מידע ותהליכים עסקיים —
          הכל במקום אחד מאובטח, מהיר ונגיש מכל מכשיר.
        </p>
      
        <div className="services">
      
          {/* FILE MANAGEMENT */}
          <div className="service-card fade-item">
            <FaCloud className="service-icon" />
      
            <h3>ניהול קבצים מתקדם</h3>
      
            <p>
              אחסון קבצים בענן עם ביצועים גבוהים וגישה מהירה מכל מקום. המערכת מאפשרת ארגון קבצים חכם,
              חיפוש מתקדם ושיתוף מאובטח בין משתמשים בתוך הארגון.
            </p>
      
            <ul className="service-list">
              <li>✔ אחסון מאובטח ומהיר</li>
              <li>✔ גישה מכל מכשיר</li>
              <li>✔ שיתוף פנימי בין עובדים</li>
              <li>✔ הגבלת שיתוף חיצוני</li>
            </ul>
          </div>
      
          {/* DATA MANAGEMENT */}
          <div className="service-card fade-item">
            <FaDatabase className="service-icon" />
      
            <h3>ניהול מידע ולקוחות</h3>
      
            <p>
              שליטה מלאה על נתונים עסקיים, לקוחות ולידים במקום אחד. מאפשר ניתוח נתונים, מעקב פעילות
              ושיפור תהליכי עבודה בצורה חכמה ואוטומטית.
            </p>
      
            <ul className="service-list">
              <li>✔ ניהול לקוחות ולידים</li>
              <li>✔ מעקב פעילות</li>
              <li>✔ אוטומציות חכמות</li>
              <li>✔ אינטגרציה בין מערכות</li>
            </ul>
          </div>
      
          {/* BUSINESS MANAGEMENT */}
          <div className="service-card fade-item">
            <FaChartLine className="service-icon" />
      
            <h3>ניהול תהליכים ועסק</h3>
      
            <p>
              מערכת לניהול עובדים, משימות, מוצרים ותהליכים עסקיים. מאפשרת שליטה מלאה בארגון,
              שיפור פרודוקטיביות וקבלת החלטות מבוססת נתונים.
            </p>
      
            <ul className="service-list">
              <li>✔ ניהול עובדים וצוותים</li>
              <li>✔ ניהול משימות ותהליכים</li>
              <li>✔ ניהול מוצרים ומלאי</li>
              <li>✔ דוחות וניתוחים מתקדמים</li>
            </ul>
          </div>
      
        </div>
      
      </section>

      {/* FEATURES */}
      <section className="sec-3">
        <h2>למה לבחור ב Techrunow Drive?</h2>

        <div className="features">

          <div className="feature">
            <h3>⚡ מהירות גבוהה</h3>
            <p>העלאה והורדה מהירה במיוחד עם ביצועים יציבים לכל סוגי הקבצים.</p>
          </div>

          <div className="feature">
            <h3>🔒 אבטחה מתקדמת</h3>
            <p>הצפנה ואבטחה ברמה גבוהה כדי לשמור על הקבצים שלך מוגנים בכל רגע.</p>
          </div>

          <div className="feature">
            <h3>🌐 גישה מכל מקום</h3>
            <p>גישה נוחה מכל מכשיר — מחשב, טאבלט או מובייל, בכל זמן.</p>
          </div>

          <div className="feature">
            <h3>📂 ניהול קבצים חכם</h3>
            <p>ארגון קבצים בצורה נוחה עם תיקיות, חיפוש מהיר ושליטה מלאה על התוכן.</p>
          </div>

        </div>
      </section>

      <section className="sec-4 fade-section">

        <h2>התוכניות שלנו</h2>
      
        <div className="plans">
      
          {/* PERSONAL */}
          <div className="plan-card fade-item">
            <h3>Personal</h3>
            <p className="price">₪39<span>/חודש</span></p>
      
            <ul>
              <li>✔ 50GB אחסון</li>
              <li>✔ ביצועים מהירים ומאובטחים</li>
              <li>✔ משתמש אחד (אימייל אחד)</li>
              <li>✔ שיתוף קבצים</li>
              <li>✔ גישה מכל מכשיר</li>
            </ul>
      
            <button className="primary-btn">התחילו עכשיו</button>
          </div>
      
          {/* BUSINESS */}
          <div className="plan-card popular fade-item">
            <span className="popular-badge">מומלץ</span>
      
            <h3>Business</h3>
            <p className="price">₪149<span>/חודש</span></p>
      
            <ul>
              <li>✔ 1TB אחסון</li>
              <li>✔ ביצועים מהירים ומאובטחים</li>
              <li>✔ עד 5 משתמשים (אימיילים)</li>
              <li>✔ שיתוף קבצים</li>
              <li>✔ גיבוי נתונים</li>
              <li>✔ תמיכה</li>
              <li>✔ ניהול מלאי</li>
              <li>✔ ניהול לקוחות</li>
              <li>✔ ניהול עובדים</li>
              <li>✔ ניהול מוצרים</li>
              <li>✔ משימות</li>
              <li>✔ חתימות דיגיטליות</li>
            </ul>
      
            <button className="primary-btn">התחילו עכשיו</button>
          </div>
      
          {/* ORGANIZATION */}
          <div className="plan-card fade-item">
            <h3>Organization</h3>
            <p className="price">₪449<span>/חודש</span></p>
      
            <ul>
              <li>✔ אחסון ללא הגבלה</li>
              <li>✔ ביצועים מקסימליים ואבטחה מתקדמת</li>
              <li>✔ משתמשים ללא הגבלה</li>
              <li>✔ כל הפיצ'רים של Business</li>
              <li>✔ שליטה ארגונית מלאה</li>
              <li>✔ הרשאות מתקדמות</li>
              <li>✔ תמיכה 24/7</li>
            </ul>
      
            <button className="primary-btn">התחילו עכשיו</button>
          </div>
      
        </div>
      
      </section>
      
      <section className="sec-5">
      
        <h2>למי זה מתאים?</h2>
      
        <div className="use-cases">
      
          <div className="case">
            <h3>עסקים קטנים</h3>
            <p>ניהול קבצים ולקוחות בצורה פשוטה ונוחה.</p>
          </div>
      
          <div className="case">
            <h3>חברות וסטארטאפים</h3>
            <p>שליטה מלאה בתהליכים, צוותים ונתונים.</p>
          </div>
      
          <div className="case">
            <h3>ארגונים גדולים</h3>
            <p>ניהול מתקדם, אבטחה גבוהה ותשתית מלאה.</p>
          </div>
      
        </div>
      
      </section>

      <footer className="footer">

        <div className="footer-container">
      
          {/* LEFT - LOGO */}
          <div className="footer-brand">
            <img src={Logo} alt="Techrunow Logo" />
            <p>Techrunow — פתרונות חכמים לניהול ארגונים ותוכנה מתקדמת.</p>
          </div>
      
          {/* LINKS */}
          <div className="footer-links">
      
            <div className="footer-col">
              <h4>פלטפורמה</h4>
              <a href="/">Drive</a>
              <a href="/">CRM (בקרוב)</a>
              <a href="/">ניהול עסקי</a>
            </div>
      
            <div className="footer-col">
              <h4>חברה</h4>
              <a href="/">שירותים</a>
              <a href="/">תוכניות</a>
            </div>
      
            <div className="footer-col">
              <h4>גישה מהירה</h4>
              <a href="/">התחילו עכשיו</a>
              <a href="/Login">התחברות</a>
            </div>
      
          </div>
      
        </div>
      
        {/* BOTTOM */}
        <div className="footer-bottom">
          © 2026 Techrunow. כל הזכויות שמורות.
        </div>
      
      </footer>

    </div>
  );
}

export default Home;